import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../lib/api";
import { FacebookLogo } from "@phosphor-icons/react";

const HIDDEN_PREFIXES = ["/admin", "/merchant", "/scanner"];

export default function MessengerButton() {
  const loc = useLocation();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let mounted = true;
    api.get("/settings/payment").then(({ data }) => { if (mounted) setSettings(data); }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!settings) return null;
  if (!settings.chat_button_enabled) return null;
  if (!settings.facebook_messenger_url) return null;
  if (HIDDEN_PREFIXES.some((p) => loc.pathname.startsWith(p))) return null;

  const buildUrl = () => {
    const base = settings.facebook_messenger_url.trim();
    if (!settings.chat_default_message) return base;
    const sep = base.includes("?") ? "&" : "?";
    return `${base}${sep}text=${encodeURIComponent(settings.chat_default_message)}`;
  };

  return (
    <a
      href={buildUrl()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="messenger-chat-button"
      aria-label="Chat on Messenger"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-2 pl-3 pr-4 py-3 rounded-full shadow-2xl border border-[#D4AF37]/40 bg-[#0a0a0a] hover:bg-[#111] transition-all"
      style={{ boxShadow: "0 12px 32px rgba(0,0,0,.55), 0 0 0 1px rgba(212,175,55,.15)" }}
    >
      <span className="flex items-center justify-center h-9 w-9 rounded-full bg-gold-gradient text-black">
        <FacebookLogo size={20} weight="fill" />
      </span>
      <span className="text-[11px] tracking-luxe uppercase text-white/90 hidden sm:inline">Chat with us</span>
    </a>
  );
}
